<div class="sidebar-container">
    @if (!isMobileSize && isAllowedToCollapse) {
        <button id="sidebar-toggle"
                class="sidebar-toggle"
                data-tour="sidebar-toggle"
                (click)="toggleSidebarOpenClosed()">
            <i [ngClass]="toggleIconClass"></i>
            <span class="visually-hidden">Slide Sidebar In/Out</span>
        </button>
    }

    @if (!isMobileSize && (tabs.length > 1 || hasPopover)) {
        <div class="vertical-tabs">
            <div class="vertical-tabs vertical-tabs-top">
                @for (tab of tabsTop; track tab) {
                    <ng-container [ngTemplateOutlet]="tabTemplate"
                                  [ngTemplateOutletContext]="{ $implicit: tab }"></ng-container>
                }
            </div>
            <div class="vertical-tabs vertical-tabs-bottom mt-auto">
                @for (tab of tabsBottom; track tab) {
                    <ng-container [ngTemplateOutlet]="tabTemplate"
                                  [ngTemplateOutletContext]="{ $implicit: tab }"></ng-container>
                }
                @for (popover of popovers$ | async; track popover) {
                    <adapt-shell-popover-link-item class="tab"
                                                   [item]="popover"
                                                   [isInternal]="popover.isInternal"
                                                   popoverLocation="right"></adapt-shell-popover-link-item>
                }
                @for (tab of tabsBottomMost; track tab) {
                    <ng-container [ngTemplateOutlet]="tabTemplate"
                                  [ngTemplateOutletContext]="{ $implicit: tab }"></ng-container>
                }
            </div>
        </div>
    }

    @if (isMobileSize) {
        <div class="horizontal-tabs">
            @for (tab of tabs; track tab) {
                <ng-container [ngTemplateOutlet]="tabTemplate"
                              [ngTemplateOutletContext]="{ $implicit: tab }"></ng-container>
            }
            @for (popover of popovers$ | async; track popover; let first = $first) {
                <adapt-shell-popover-link-item class="tab"
                                               [ngClass]="{ 'first-popover': first }"
                                               [item]="popover"
                                               [isInternal]="popover.isInternal"
                                               popoverLocation="bottom"></adapt-shell-popover-link-item>
            }
            <button class="mobile-sidebar-toggle"
                    (click)="toggleSidebarOpenClosed()">
                <i class="fal fa-times"></i>
            </button>
        </div>
    }

    <div class="tab-content"
         #tabContent>
        <div class="tab-content-resize-handle"
             #resizeHandle></div>
        @if (tabIsLoading) {
            <adapt-loading-spinner class="h-100"></adapt-loading-spinner>
        }

        <dx-scroll-view [hidden]="tabIsLoading"
                        direction="vertical"
                        showScrollbar="onHover"
                        [useNative]="false">
            <adapt-render-component class="scroll-view-content"
                                    [hidden]="tabIsLoading"
                                    [component]="activeTab?.content?.component"
                                    [componentInputs]="activeTab?.content?.params"
                                    [eagerRenderComponents]="tabContentComponents"> </adapt-render-component>
        </dx-scroll-view>
    </div>

    <button class="d-md-none logout-button"
            (click)="promiseToLogout()">
        <i class="fal fa-sign-out"></i>
        Logout
    </button>
</div>

<ng-template #tabTemplate
             let-tab>
    <adapt-render-component class="tab"
                            [id]="tab.id"
                            [hidden]="!activeTab || !(tab.isDisplayed$ | async)"
                            [ngClass]="{
            active: tab === activeTab || (tab.isActive$ && tab.isActive$ | async),
            'has-text': !!tab?.icon?.params?.iconText,
        }"
                            [component]="tab.icon.component"
                            [componentInputs]="tab.icon.params"
                            (click)="tabClick(tab)">
    </adapt-render-component>
</ng-template>
